export default {
  folder: "t2",
  initialFrame: 21,
  interior: {
    points: [
      [2200, -300, 0], // 15.6 Inch High-resolution Color Touch Screen
      [1800, -1300, 1400], // 12 Channel Sony Audio
      [1000, 2000, 0], // Panoramic Sunroof
      [1000, -1600, -800], // Ventilated Seats
      [2200, -1600, 0], // 7 Drive Modes
      [2200, -600, -1100], // Multi-function Steering Wheel 
      [2200, -1150, -200], // Wireless Phone Charging
    ],
  },
  exterior: {
    hotspots: {
      h1: {
        // Expandable Feature Tailgate
        popup: 1,
        point: [
          [50, 29], // f1
          [45, 29], // f2
          [39, 28], // f3
          [34, 29], // f4
          [29, 28], // f5
          [24, 28], // f6
          [21, 28], // f7
          [20, 28], // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          [78, 29], // f31
          [75, 29], // f32
          [71, 29], // f33
          [66, 28], // f34
          [63, 28], // f35
          [56, 28], // f36
        ],
      },
      h2: {
        // Magic Electric Door
        popup: 2,
        point: [
          [40, 48], // f1
          [34, 48], // f2
          [28, 48], // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          [79, 46], // f30
          [76, 47], // f31
          [72, 48], // f32
          [67, 48], // f33
          [61, 48], // f34
          [54, 48], // f35
          [47, 48], // f36
        ],
      },
      h3: {
        // Kunpeng Power 2.0TGDI
        popup: 3,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          null, // f10
          [73, 41], // f11
          [71, 41], // f12
          [70, 42], // f13
          [67, 42], // f14
          [64, 42], // f15
          [61, 42], // f16
          [58, 43], // f17
          [54, 42], // f18
          [49, 43], // f19
          [44, 43], // f20
          [42, 43], // f21
          [38, 42], // f22
          [34, 42], // f23
          [31, 42], // f24
          [29, 42], // f25
          [27, 41], // f26
          [26, 41], // f27
          [25, 42], // f28
          [25, 42], // f29
          [25, 42], // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      h4: {
        // 540° Panoramic Parking System
        popup: 4,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          [66, 36], // f6
          [65, 37], // f7
          [63, 37], // f8
          [61, 37], // f9
          [57, 37], // f10
          [55, 37], // f11
          [52, 37], // f12
          [49, 37], // f13
          [46, 37], // f14
          [43, 37], // f15
          [40, 37], // f16
          [37, 37], // f17
          [36, 37], // f18
          [64, 37], // f19
          [63, 37], // f20
          [61, 37], // f21
          [58, 37], // f22
          [55, 37], // f23
          [52, 37], // f24
          [49, 37], // f25
          [46, 37], // f26
          [43, 37], // f27
          [40, 37], // f28
          [37, 37], // f29
          [35, 37], // f30
          [34, 37], // f31
          [33, 37], // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      h5: {
        // LED Head Lights
        popup: 5,
        point: [
          null, // f1
          null, // f2
          null, // f3
          null, // f4
          null, // f5
          null, // f6
          null, // f7
          null, // f8
          null, // f9
          [82, 49], // f10
          [80, 50], // f11
          [77, 50], // f12
          [73, 51], // f13
          [68, 51], // f14
          [62, 51], // f15
          [56, 52], // f16
          [50, 52], // f17
          [66, 51], // f18
          [60, 51], // f19
          [54, 52], // f20
          [48, 52], // f21
          [41, 52], // f22
          [34, 52], // f23
          [28, 51], // f24
          [24, 51], // f25
          [21, 50], // f26
          [19, 50], // f27
          [18, 49], // f28
          null, // f29
          null, // f30
          null, // f31
          null, // f32
          null, // f33
          null, // f34
          null, // f35
          null, // f36
        ],
      },
      h6: {
        // Spare Wheel Cover
        popup: 6,
        point: [
          [49, 47], // f1
          [42, 47], // f2
          [34, 47], // f3
          [28, 47], // f4
          [23, 46], // f5
          [18, 46], // f6
          [15, 45], // f7
          null, // f8
          null, // f9
          null, // f10
          null, // f11
          null, // f12
          null, // f13
          null, // f14
          null, // f15
          null, // f16
          null, // f17
          null, // f18
          null, // f19
          null, // f20
          null, // f21
          null, // f22
          null, // f23
          null, // f24
          null, // f25
          null, // f26
          null, // f27
          null, // f28
          null, // f29
          null, // f30
          [84, 45], // f31
          [81, 46], // f32
          [77, 46], // f33
          [72, 48], // f34
          [65, 47], // f35
          [58, 47], // f36
        ],
      },
    },
  },
};
